export const useErrorLogout = () => () => {
	window.location.reload();
	localStorage.removeItem('refresh');
	localStorage.removeItem('token');
	window.location.reload();
};
